module.exports = __webpack_public_path__ + "static/media/gnome-software-logo.f74f3755.svg";